import {apiService} from '../apiService';

export const lookupsService = apiService.injectEndpoints({
    endpoints: (builder) =>
        ({
            getDietaryNeedOptions: builder.query({
                query: () => ({
                    url: '/lookup/special-dietary-needs'
                })
            }),
            getWelfareOptions: builder.query({
                query: () => ({
                    url: '/lookup/welfare'
                })
            }),
            getMedicalConsentOptions: builder.query({
                query: () => ({
                    url: '/lookup/medical-consents'
                }),
                providesTags: (_) => ['MedicalConsents']
            }),
            manageMedicalConsents: builder.mutation({
                query: (body) => ({
                    url: '/lookup/medical-consents',
                    method: 'POST',
                    data: body,
                }),
                invalidatesTags: ['MedicalConsents']
            }),
            getTravelOptions: builder.query({
                query: () => ({
                    url: '/lookup/travels'
                }),
            }),
            getMedicalEventTypes: builder.query({
                query: () => ({
                    url: '/lookup/medical-events'
                }),
            }),
            getContactTitles: builder.query({
                query: () => ({
                    url: '/lookup/titles'
                }),
            }),
            getConsentLookups: builder.query({
                query: () => ({
                    url: '/lookup/consents'
                }),
                providesTags: (_) => ['ConsentLookups']
            }),
            getSchools: builder.query({
                query: () => ({
                    url: '/lookup/schools'
                }),
            }),
            getGenders: builder.query({
                query: () => ({
                    url: '/lookup/genders'
                }),
            }),
            getRelationships: builder.query({
                query: () => ({
                    url: '/lookup/relationships'
                }),
            }),
            getBoarderStatuses: builder.query({
                query: () => ({
                    url: '/lookup/boarder-statuses'
                }),
            }),
            getRelations: builder.query({
                query: () => ({
                    url: '/lookup/relations'
                }),
            }),
            getCountries: builder.query({
                query: () => ({
                    url: '/country/list'
                }),
            }),
            getReligions: builder.query({
                query: () => ({
                    url: '/lookup/religions',
                    method: 'GET',
                }),
                providesTags: ['Religions'],
            }),
            GetNextOfKinTypes: builder.query({
                query: () => ({
                    url: '/lookup/next-of-kin-types'
                }),
            }),
            GetEmployeeContactTypes: builder.query({
                query: () => ({
                    url: '/lookup/employee-contact-types'
                }),
            }),
        }),
});

export const {
    useGetDietaryNeedOptionsQuery,
    useGetWelfareOptionsQuery,
    useGetMedicalConsentOptionsQuery,
    useManageMedicalConsentsMutation,
    useGetTravelOptionsQuery,
    useGetMedicalEventTypesQuery,
    useGetContactTitlesQuery,
    useGetConsentLookupsQuery,
    useGetGendersQuery,
    useGetRelationshipsQuery,
    useGetBoarderStatusesQuery,
    useGetSchoolsQuery,
    useGetRelationsQuery,
    useGetCountriesQuery,
    useGetReligionsQuery,
    useGetNextOfKinTypesQuery,
    useGetEmployeeContactTypesQuery
} = lookupsService;
